export enum BaseIcons {
    New = 'plus',
    Edit = 'edit',
    Delete = 'trash',
    Save = 'save',
    Cancel = 'remove',
    Undo = 'undo',
    Redo = 'redo',
    Refresh = 'refresh',
    Execute = 'video',
    Export = 'export',
    GenerateAsExcel = 'xlsxfile',
    GenerateAllAsExcel = 'exportxlsx',
    GenerateAsPdf = 'pdffile',
    GenerateAllAsPdf = 'exportpdf',
    GenerateAsWord = 'textdocument',
    GenerateAllAsWord = 'export',
    Print = 'print',
    Create = 'save',
    Update = 'save',
    Dropzone = 'dropzone',
    Preferences = 'preferences',
    Gear = 'optionsgear',
    Percent = 'percent',
    Pin = 'pin',
    Unpin = 'unpin',
    Pulldown = 'pulldown',
    Repeat = 'repeat',
}
